import React, { Component } from "react";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Link from "@material-ui/core/Link";
import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { withStyles } from "@material-ui/core/styles";
import { ToastContainer, toast } from "react-toastify";
import { connect } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import { Redirect } from "react-router-dom";
import io from "socket.io-client";
import Snackbar from "@material-ui/core/Snackbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
const socketUrl = "https://silver-house.ir";
const styles = theme => ({
  root: {
    height: "100vh",
    paddingBottom: "0"
  },
  image: {
    backgroundImage: "url(https://source.unsplash.com/user/erondu/likes)",
    backgroundRepeat: "no-repeat",
    backgroundColor:
      theme.palette.type === "dark"
        ? theme.palette.grey[900]
        : theme.palette.grey[50],
    backgroundSize: "cover",
    backgroundPosition: "center"
  },
  paper: {
    margin: theme.spacing(8, 4),
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1)
  },
  submit: {
    margin: theme.spacing(3, 0, 2)
  }
});

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: ""
    };
  }
  componentDidMount() {
    document.title = "ورود";
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let login_param = params.get("go-login");
    login_param
      ? toast.error("ابتدا وارد شوید", { position: toast.POSITION.BOTTOM_LEFT })
      : console.log();
    this.initSocket();
  }
  initSocket = () => {
    const socket = io(socketUrl);
    socket.on("connect", res => {
      this.setState({ socket });
    });
  };
  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value }, () => {});
  };
  handleLogin = () => {
    const { username, password } = this.state;
    if (username.trim() === "" || password.trim() === "") {
      this.setState({messageInfo:"نام کاربری و رمز عبور خود را وارد نمایید" , open:true , hasError:true})
      
    } else if (password.length < 6) {
      this.setState({messageInfo:"رمز عبور حداقل باید 6 کاراکتر باشد" , open:true, hasError:true})
    } else {
      const { socket } = this.state;
      socket.once("login", data => {
        
        if (!data.error) {
          this.setState({messageInfo:"شما با موفقیت وارد شدید" , open:true,hasError:false})
          localStorage.setItem("token", data.data.token);
          setTimeout(() => {
             this.setState({is_loddein_in:true});
          }, 1000);
        } else {
          this.setState({messageInfo:data.message , open:true, hasError:true})
        }
      });
      socket.emit("login", { username, password });
    }
  };
  handleClose = ()=>{
    this.setState({open:false});
  }
  render() {
    const { classes } = this.props;
    const { username, password, is_loddein_in , messageInfo , open,hasError } = this.state;
    return is_loddein_in ? (
      <Redirect to="/" />
    ) : (
      <Grid container component="main" className={classes.root}>
        <CssBaseline />
        <Grid item xs={false} sm={4} md={7} className={classes.image} />
        <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
          <div className={classes.paper}>
            <Avatar className={classes.avatar}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              ورود
            </Typography>

            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="username"
              label="نام کاربری"
              name="username"
              autoComplete="username"
              value={username}
              onChange={this.handleChange}
              autoFocus
              className="login-txt"
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              onChange={this.handleChange}
              name="password"
              value={password}
              label="رمز عبور"
              type="password"
              id="password"
              className="login-txt"
              autoComplete="current-password"
            />
            <Button
              type="button"
              fullWidth
              variant="contained"
              color="primary"
              onClick={this.handleLogin}
              className={classes.submit}
            >
              ورود
            </Button>
            <Box mt={5}>
              <Typography variant="body2" color="textSecondary" align="center">
                {"کپی رایت © "}
                <Link color="inherit" href="https://silver-house.ir/">
                  خانه نقره
                </Link>{" "}
                {new Date().getFullYear()}
                {"."}
              </Typography>
            </Box>
          </div>
        </Grid>
        <ToastContainer autoClose={3000} />
        <Snackbar
          key={messageInfo ? messageInfo : undefined}
          className={hasError?"error-msg":'success-msg' }
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left"
          }}
          open={open}
          severity="success"
          autoHideDuration={6000}
          onClose={this.handleClose}
          onExited={this.handleExited}
          message={messageInfo ? messageInfo : undefined}
          action={
            <React.Fragment>
              <IconButton
                aria-label="close"
                color="inherit"
                onClick={this.handleClose}
              >
                <CloseIcon />
              </IconButton>
            </React.Fragment>
          }
        />
      </Grid>
    );
  }
}
const mapStateToProps = state => {
  return {
    socket: state.setSocket
  };
};
export default connect(mapStateToProps)(withStyles(styles)(Login));
